module.exports = __webpack_public_path__ + "static/toyota-case-study-2ea9e8c0890ac66285988d342d5c6bb2.webp";